import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const ValidateExternalRefundTaskMessage = ({
  article,
}: {
  article: ArticleWithRelations;
}) => {
  return (
    <BaseMessage
      title={
        <Trans id="article.task.validate-external-refund.title">
          Waiting for refund information
        </Trans>
      }
      message={
        <Trans id="article.task.validate-external-refund.message">
          Please provide the required refund details on the request page to validate the step
        </Trans>
      }
      article={article}
    />
  );
};
